var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuiS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8185 7.45241C11.0172 10.6667 7.76161 12.6229 4.54691 11.8213C1.33356 11.02 -0.622614 7.76422 0.179081 4.55016C0.980072 1.33549 4.23565 -0.620826 7.44936 0.180517C10.6638 0.98186 12.6199 4.238 11.8184 7.45246L11.8185 7.45241H11.8185Z",
    fill: "#4CA3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80114 5.33622C8.11396 5.74595 8.30104 6.26411 8.30104 6.82776C8.30104 7.3914 8.10828 7.92538 7.78724 8.3374L7.75942 8.37301L7.75216 8.32784C7.74584 8.2896 7.73858 8.25071 7.73004 8.21182C7.5692 7.47479 7.0453 6.84292 6.18296 6.33102C5.60058 5.98624 5.26722 5.57158 5.1797 5.09989C5.12314 4.79501 5.16516 4.48879 5.24636 4.2264C5.32758 3.96436 5.44828 3.7445 5.55098 3.61233L5.88656 3.18448C5.94534 3.10933 6.05562 3.10933 6.11438 3.18448L7.80146 5.33622H7.80114ZM8.33168 4.90871L6.0831 2.04104C6.04014 1.98632 5.95986 1.98632 5.9169 2.04104L3.66863 4.90871L3.66137 4.91828C3.24774 5.45391 3 6.13457 3 6.87555C3 8.6011 4.34327 10 6 10C7.65674 10 9 8.6011 9 6.87555C9 6.13457 8.75226 5.45391 8.33864 4.9186L8.33136 4.90904L8.33168 4.90871ZM4.20676 5.327L4.40773 5.07023L4.41374 5.11769C4.41847 5.15526 4.42448 5.19284 4.43143 5.23074C4.56162 5.94306 5.02644 6.5367 5.80346 6.99651C6.47904 7.39766 6.87244 7.85881 6.98556 8.36443C7.03296 8.5754 7.04118 8.78304 7.02064 8.96467L7.01938 8.97587L7.00958 8.98082C6.70466 9.13606 6.3618 9.22341 5.99968 9.22341C4.72909 9.22341 3.69897 8.15084 3.69897 6.82742C3.69897 6.25917 3.88888 5.73737 4.20613 5.32634L4.20676 5.327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuiS);
export default __webpack_public_path__ + "static/media/sui-s.861421f1c0168716f58815668ff25fce.svg";
export { ForwardRef as ReactComponent };